import { render, staticRenderFns } from "./pub.vue?vue&type=template&id=7bdb8e61&"
import script from "./pub.vue?vue&type=script&lang=js&"
export * from "./pub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports